import { Axios, ToJson, UrlFactory } from "@gsx/common";
import {
    ReportBody,
    ReportListItem,
    ReportListQuery,
    ReportListResponse,
} from "@gsx/common/src/types/http/admin/report";
import { adaptDate } from "../adapters";

const adaptRequest = (data: any): ReportListItem => ({
    ...data,
    submissionDate: adaptDate(data.submissionDate),
});

export class Report {
    private readonly urlFactory: UrlFactory;

    public constructor(private readonly axios: Axios, urlFactory: UrlFactory) {
        this.urlFactory = urlFactory.to("/admin/reports");
    }

    public async list(params: ReportListQuery): Promise<ReportListResponse> {
        const url = this.urlFactory.create("/");
        const response = await this.axios.get(url, { params });
        return {
            ...response.data,
            data: response.data.data.map(adaptRequest),
        };
    }

    public async create(body: Partial<ToJson<ReportBody>>, formData: FormData): Promise<void> {
        const url = this.urlFactory.create(`/`);
        await this.axios
            .post(url, body)
            .then(async (res) => this.uploadMedia(res.data.id, formData));
    }

    public async update(
        id: string,
        body: Partial<ToJson<ReportBody>>,
        formData: FormData,
    ): Promise<void> {
        const url = this.urlFactory.create(`/${id}`);
        await this.axios.put(url, body).then(async () => this.uploadMedia(id, formData));
    }

    public async get(id: string): Promise<ReportBody> {
        const url = this.urlFactory.create(`/${id}`);
        const response = await this.axios.get(url);
        return response.data as ReportBody;
    }

    public async delete(id: string): Promise<void> {
        const url = this.urlFactory.create(`/${id}`);
        await this.axios.delete(url);
    }

    public async sendEmail(report: any) {
        const url = this.urlFactory.create(`/sendEmail`);
        await this.axios.post(url, report);
    }

    private async uploadMedia(id: string, formData: FormData) {
        if (
            (formData.has("pdf") && formData.get("pdf") !== "null") ||
            (formData.has("picture") && formData.get("picture") !== "null")
        ) {
            const reportMediaUrl = this.urlFactory.create(`/${id}/media`);

            await this.axios.put(reportMediaUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        }
    }
}
